import { render, staticRenderFns } from "./selectDatetime_wx.vue?vue&type=template&id=12618e2b&scoped=true"
import script from "./selectDatetime_wx.vue?vue&type=script&lang=js"
export * from "./selectDatetime_wx.vue?vue&type=script&lang=js"
import style0 from "./selectDatetime_wx.vue?vue&type=style&index=0&id=12618e2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12618e2b",
  null
  
)

export default component.exports